import type { ReactNode } from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import BackToTop from "./BackToTop";

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50 font-body text-foreground-900">
      <SiteHeader />
      <main className="flex-1 w-full">{children}</main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}